/**
 * UI 무효화 배치 스케줄러 (일감 G3) — 게임플레이 mutation의 refreshAll 남발(풀 rebuild ~30곳)을
 * "첫 invalidate 후 delayMs(기본 50ms)에 1회 flush" 배치 윈도로 통합한다.
 *
 * 순수 모듈: 타이머는 주입(RefreshTimer) — 앱은 scene.time.delayedCall(셧다운 시 자동 정리),
 * 테스트는 fake timer. flush 알림은 Signal(주입형 typed 도메인 이벤트)로 전파 — 구독자(GameScene)가
 * battleTab + 활성 탭 갱신으로 라우팅한다(숨은 탭은 활성화/250ms 루프가 갱신).
 *
 * 디바운스가 아니라 배치 윈도인 이유: trailing 리셋 방식은 연속 mutation(연사 골드 획득 등)에서
 * flush가 무한 연기될 수 있다 — 첫 invalidate 기준 고정 윈도는 최대 지연이 delayMs로 유계.
 */
import { Signal } from "./Signal.js";

export interface RefreshTimer {
  /** delayMs 후 cb를 1회 실행 예약. 반환값은 취소 함수. */
  schedule(cb: () => void, delayMs: number): () => void;
}

export class RefreshScheduler {
  /** 배치 윈도 도달 — 구독자가 실제 갱신(라우팅)을 수행한다. */
  readonly flushed = new Signal<void>();

  private cancelPending: (() => void) | null = null;

  constructor(
    private readonly timer: RefreshTimer,
    private readonly delayMs = 50,
  ) {}

  /** UI 무효화 표시. 윈도가 이미 열려 있으면 병합(no-op) — N회 호출 = 1회 flush. */
  invalidate(): void {
    if (this.cancelPending !== null) return;
    this.cancelPending = this.timer.schedule(() => {
      this.cancelPending = null;
      this.flushed.emit();
    }, this.delayMs);
  }

  get hasPending(): boolean {
    return this.cancelPending !== null;
  }

  /** 대기 중 배치 취소 (씬 종료 등). 구독은 유지된다. */
  dispose(): void {
    this.cancelPending?.();
    this.cancelPending = null;
  }
}
